module.exports = __webpack_public_path__ + "static/img/role.4fce2df.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/xk/role.png
// module id = 6vgd
// module chunks = 7